import React from "react";
import { useTranslation } from "react-i18next";

const EmployeeSubscribedToMonthlyBenefit = () => {
  const { t } = useTranslation();
  return (
    <>
      <h4 className="notification-title">
        {t("subscribed_success_to_monthly_title")}
      </h4>
      <p className="notification-subtitle">
        {t("subscribed_success_to_monthly_info")}
      </p>
    </>
  );
};

export default EmployeeSubscribedToMonthlyBenefit;
